jQuery($ => {
    if ($('.o-notification-bar')[0]) {
        var data_id = $('.o-notification-bar').attr('data-id');

        if (localStorage.getItem('popState_' + data_id) != 'shown') {
            $('.o-notification-bar').delay(2000).slideDown();

            if ($('.o-lesson-header')[0]) {
                $('.o-lesson-header').delay(2000).addClass('o-lesson-header--has-notification-bar');
            }
        }

        $('.o-notification-bar__close-button').click(function () {
            localStorage.setItem('popState_' + data_id, 'shown');

            $(this).remove();

            $('.o-notification-bar').slideUp();

            if ($('.o-lesson-header--has-notification-bar')[0]) {
                $('.o-lesson-header').removeClass('o-lesson-header--has-notification-bar');
            }
        });
    }

});